import React from 'react'
import '../App.css';
import { Link } from 'react-router-dom'
import { Badge } from 'react-bootstrap';

export class Bodyheadregister extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className='sshbodyappContainerRegister'>
                <div className='container'>
                    <div className="row">
                        <div className="col col-lg-7">
                            
                        </div>
                        <div className="col col-lg-5">
                            <h5>
                                Aún no está registrado?<Link to={`/Register`}><Badge bg="secondary">Registrarme</Badge></Link> 
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}